import { Menu, Bell } from "lucide-react";
import { jwtDecode } from "jwt-decode";
import { getToken } from "../../services/auth";

export default function AdminNavbar({ onMenuClick }) {
  const token = getToken();
  let email = "Admin";
  try {
    email = jwtDecode(token)?.email || "Admin";
  } catch {}

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-slate-200 bg-white/90 px-4 shadow-sm backdrop-blur-xl dark:border-slate-800 dark:bg-slate-950/90 sm:px-6">
      <button
        onClick={onMenuClick}
        className="rounded-lg p-2 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-900 lg:hidden"
      >
        <Menu size={22} />
      </button>

      <div className="flex-1 lg:flex-none">
        <h2 className="text-sm font-semibold text-slate-500 dark:text-slate-400 hidden lg:block">
          Super Admin Dashboard
        </h2>
      </div>

      <div className="flex items-center gap-4">
        <button className="relative rounded-lg p-2 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-900">
          <Bell size={20} />
          <span className="absolute top-1 right-1 w-2 h-2 rounded-full bg-red-500" />
        </button>
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-sm font-extrabold">
            {email[0]?.toUpperCase()}
          </div>
          <div className="hidden md:block">
            <div className="text-sm font-semibold text-slate-800 dark:text-white">{email.split("@")[0]}</div>
            <div className="text-xs text-slate-400">Super Admin</div>
          </div>
        </div>
      </div>
    </header>
  );
}
